export function uniqueFieldsFromSchema(schema) {
    return schema.filter(col => col.unique_group === true).map(col => col.name);
}
